{
  "account": {
    "biometrics": {
      "download_biometrics": {
        "p1": "PL Download a copy of my biometric data.",
        "title": "PL Biometrics Download"
      },
      "face": "PL Face",
      "iproov_config": {
        "opt_status": {
          "use_iproov": "PL Use iProov (recommended)",
          "use_standard": "PL Use an alternative method"
        },
        "p1": "PL You may opt in or out of using iProov.",
        "save": "PL Save changes",
        "title": "PL iProov configuration"
      },
      "manage_biometrics": {
        "options": {
          "download": "PL Download biometrics",
          "iproov": "PL iProov configuration"
        },
        "title": "PL Manage Biometrics"
      },
      "voice": "PL Voice"
    },
    "delete": {
      "button": "PL Confirm",
      "key": "PL DELETE ME",
      "label": "PL To confirm please type \"PL DELETE ME\" in all capital letters.",
      "p1": "PL You may delete your Nomidio ID account.",
      "title": "PL Delete Account"
    },
    "details": {
      "options": {
        "email": "PL Email Addresses",
        "names": "PL First & Last Names",
        "phone": "PL Phone Numbers"
      },
      "title": "PL Account Details"
    },
    "edit_details": {
      "alert": {
        "save_error": "PL There was an error updating your details. Please try again.",
        "save_success": "PL Account details updated"
      },
      "button": "PL Save changes",
      "leave_dialog": {
        "cancel": "PL Cancel",
        "confirm": "PL Yes",
        "content": "PL Are you sure you want to leave this page without saving your changes?",
        "title": "PL "
      },
      "p1": "PL You may edit your name which is associated with your Nomidio ID",
      "title": "PL Edit Account Details"
    },
    "email": {
      "approver": {
        "error": {
          "too_many_attempts": "PL You have made too many incorrect attempts. Please try again later..",
          "wrong_email": "PL This isn't the email that was entered for your manager. Please check with the person that invited you and try again."
        },
        "manager": {
          "title": "PL Manager's email address"
        },
        "p1": "PL When your corporate email was created, a specific manager's email address was nominated for your approver.",
        "p2": "PL A six-digit verification code will be sent to that manager to approve your email.",
        "title": "PL Enter manager email"
      },
      "button": "PL Edit",
      "edit": {
        "add_email": {
          "button": "PL Add Email"
        },
        "delete_dialog": {
          "cancel": "PL Cancel",
          "confirm": "PL Yes",
          "content": "PL Are you sure you want to delete the following email:",
          "title": "PL "
        },
        "delete_email": {
          "button": "PL Delete",
          "error": "PL There was an error deleting that email address. Please try again."
        },
        "fetch_error": "PL There was an error retrieving up-to-date email addresses. Please check your internet connection and refresh the page.",
        "new_email": {
          "button": "PL Send Verification Code",
          "error.corporate_email": "PL This email is a corporate email. Please contact an enterprise admin to add it to your account.",
          "error.invalid_email": "PL The email provided is invalid.",
          "error.too_many_requests": "PL You are sending too many requests. Please wait some time before trying again.",
          "error.unexpected_failure": "PL There was an error sending a verification code to this email. Please try again.",
          "title": "PL Add New Email"
        },
        "primary_email": {
          "button": "PL Make Primary",
          "error": "PL There was an error updating primary email. Please try again."
        },
        "verify_pending": {
          "button": "PL Verify"
        }
      },
      "empty": "PL You do not have any email addresses on your account.",
      "p1": "PL List of email addresses associated with your Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "PL The authentication code sent to your email has expired. Please re-submit your email address for verification.",
          "default_content": "PL We were unable to verify your new email.",
          "email_in_use": "PL The email you verified is already connected to an account. Please try again with a different email address.",
          "primary_button": "PL Ok",
          "title": "PL Verification Unsuccessful"
        },
        "success_dialog": {
          "primary_button": "PL Ok",
          "title": "PL Your email has been successfully verified"
        }
      },
      "status": {
        "tooltip": {
          "pending": "PL This email is pending and needs to be verified.",
          "suspended": "PL This email is suspended. Please delete or ask the enterprise admin to re-enable this email.",
          "verified": "PL This email is verified."
        }
      },
      "title": "PL Email Addresses",
      "type": {
        "corporate": "PL Corporate",
        "personal": "PL Personal",
        "primary": "PL Primary"
      }
    },
    "enrolments": {
      "alert": {
        "save_error": "PL Enrolment update failed!",
        "save_success": "PL Enrolment updated!"
      },
      "button": {
        "cancel": "PL Cancel",
        "retry": "PL Retry",
        "save": "PL Update"
      },
      "error": {
        "network_issue": "PL There seems to be an issue with your internet connection.",
        "server_error": "PL We are currently experiencing issues. Please try again later."
      },
      "leave_dialog": {
        "cancel": "PL Cancel",
        "confirm": "PL Yes",
        "content": "PL Are you sure you want to leave this page without saving your changes?",
        "title": "PL "
      },
      "p1": "PL You have enrolled to use Nomidio ID with these companies.",
      "p2": "PL You may enrol or de-enrol at any time.",
      "table": {
        "company_header": "PL Company",
        "enrolled_header": "PL Enrolled",
        "select_all": "PL Select All"
      },
      "title": "PL Manage Enrolled Companies"
    },
    "export": {
      "button": "PL Download",
      "loading": "PL Fetching the latest version of your data...",
      "p1": "PL Download a copy of my personal data.",
      "title": "PL Data Download"
    },
    "history": {
      "action": {
        "ACCOUNT_DETAILS_UPDATED": "PL Account details were updated",
        "DATA_REQUESTED": "PL Requested biometric data",
        "DATA_SHARED": "PL Shared data",
        "ENROLLED": "PL Enrolled with an enterprise",
        "FACE_SAMPLE_DOWNLOAD": "PL Downloaded a face sample",
        "HIGH_CHALLENGE": "PL Performed high challenge",
        "LOGIN": "PL Logged in",
        "OPEN_ID_ACCOUNT_APPROVED": "PL Nomidio ID enterprise sign-in approved",
        "OPEN_ID_ACCOUNT_REMOVED": "PL Nomidio ID sign-in access removed",
        "OPTED_IN": "PL Opted in to an enterprise",
        "OPTED_OUT": "PL Opted out of an enterprise",
        "STANDARD_CHALLENGE": "PL Performed standard challenge",
        "TERMS_AND_CONDITIONS_ACCEPTED": "PL Terms and conditions accepted",
        "TERMS_AND_CONDITIONS_REJECTED": "PL Terms and conditions rejected",
        "VOICE_SAMPLE_DOWNLOAD": "PL Downloaded a voice sample"
      },
      "button": "PL Download",
      "p1": "PL View a list of historic actions on your account.",
      "performedWith": "PL Performed with: ",
      "title": "PL Account History"
    },
    "landing": {
      "logout": "PL Log out",
      "options": {
        "2fa": {
          "add": "PL Add 2FA Authenticator",
          "loading": "PL Loading...",
          "update": "PL Update 2FA Authenticator"
        },
        "account_details": "PL Account Details",
        "biometrics": "PL Manage Biometrics",
        "companies": "PL Enrolled Companies",
        "delete": "PL Delete my Nomidio ID",
        "device": {
          "settings": "PL Device settings"
        },
        "export": "PL Data Download",
        "faq": "PL FAQ",
        "help": "PL Help",
        "history": "PL Account History",
        "privacy": "PL Privacy Notice",
        "terms": "PL Terms of Use"
      },
      "title": "PL Account Management"
    },
    "logout_dialog": {
      "cancel": "PL Cancel",
      "confirm": "PL Yes",
      "content": "PL ",
      "title": "PL Are you sure you want to log out?"
    },
    "phone": {
      "button": "PL Edit",
      "edit": {
        "delete_dialog": {
          "cancel": "PL Cancel",
          "confirm": "PL Yes",
          "content": "PL Are you sure you want to delete the following number:",
          "title": "PL "
        },
        "delete_phone": {
          "button": "PL Delete",
          "error": "PL There was an error deleting that phone number. Please try again."
        },
        "fetch_error": "PL There was an error retrieving up-to-date phone numbers. Please check your internet connection and refresh the page.",
        "leave_dialog": {
          "cancel": "PL Cancel",
          "confirm": "PL Yes",
          "content": "PL Are you sure you want to leave this page without saving your changes?",
          "title": "PL "
        },
        "new_phone": {
          "button": "PL Verify",
          "error.landline": "PL Only mobile numbers can be added.",
          "error.unexpected_failure": "PL There was an error sending a verification code to your phone. Please try again.",
          "title": "PL Add New Phone Number"
        },
        "phone_list": {
          "title": "PL Edit Current Phone Numbers"
        },
        "primary_phone": {
          "button": "PL Make Primary",
          "error": "PL There was an error updating primary phone. Please try again."
        }
      },
      "empty": "PL You do not have any phone numbers on your account.",
      "p1": "PL List of phone numbers associated with your Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "PL The authentication code sent to your phone has expired. Please re-submit your phone number for verification.",
          "default_content": "PL We were unable to verify your new phone, it has not been added.",
          "phone_in_use": "PL The phone number you verified is already connected to an account. Please try again with a different phone number.",
          "primary_button": "PL Ok",
          "title": "PL An Error Occurred"
        },
        "success_dialog": {
          "primary_button": "PL Ok",
          "title": "PL Your phone has been successfully verified"
        }
      },
      "title": "PL Phone Numbers",
      "type": {
        "dedicated_landline": "PL Dedicated Landline",
        "mobile": "PL Mobile",
        "primary": "PL Primary",
        "shared_landline": "PL Shared Landline"
      }
    },
    "totp": {
      "continue": "PL Create Authenticator Secret",
      "description": "PL Add two-factor authentication using an authenticator app.",
      "title": "PL Two-Factor Authentication",
      "verified": {
        "confirm": "PL Ok",
        "content": "PL You have successfully added an authenticator to your account.",
        "title": "PL TOTP Authenticator Added"
      },
      "verify": {
        "authenticator": {
          "p1": "PL You'll need an authenticator app on your device to proceed with this step. We recommend using an app such as Google Authenticator.",
          "title": "PL Don't have an authenticator?"
        },
        "button": "PL Verify",
        "step1": {
          "title": "PL Step 1. Scan the QR code"
        },
        "step2": {
          "p1": "PL Enter the 6 digit code displayed in the authenticator app.",
          "p2": "PL Codes are timed, so be sure to enter it and click verify before it is recycled.",
          "title": "PL Step 2. Enter your security code"
        },
        "title": "PL Register an Authenticator"
      },
      "warning": "PL Creating a new secret will automatically disable an existing one."
    },
    "welcome_dialog": {
      "content": "PL Your Nomidio ID has been successfully created. You will receive an email with additional account management information.",
      "primary_button": "PL Ok",
      "title": "PL Welcome to Nomidio Identity"
    }
  },
  "auth": {
    "login": {
      "landing": {
        "p1": "PL To authenticate using your Nomidio ID you will need to pass a biometric check.",
        "title": "PL Welcome to Nomidio ID"
      }
    }
  },
  "avatar": {
    "review": {
      "pending": "PL Pending approval",
      "rejected": "PL Rejected",
      "verified": "PL Verified"
    },
    "upload": {
      "failed": "PL Unable to set that image as your profile picture.",
      "pending": "PL Uploading ..."
    }
  },
  "branding": {
    "powered_by_pq": "PL Powered by Post-Quantum"
  },
  "browser_compatibility": {
    "android_web_view": {
      "li1": "PL Press the menu in the corner",
      "li2": "PL Select \"Open in Chrome\"",
      "open": "PL Please open this link in Chrome or Firefox. You can do so with the following steps:",
      "title": "PL This in-app browser is not supported."
    },
    "unsupported": {
      "direction": "PL Please open this link in Chrome or Firefox for Android, or Safari on iOS",
      "open": "PL It looks like you are using a non-compatible browser.",
      "title": "PL Unsupported Browser"
    }
  },
  "browser_problem_link": {
    "text": "PL Problem with browser?"
  },
  "challenge": {
    "pin": {
      "browser": {
        "click": "PL Click here to copy",
        "error": {
          "incomplete": "PL It looks like your login was incomplete, please reopen the link and try again.",
          "link": "PL The link you used was inaccurate.",
          "request": "PL There was an issue retrieving your pin, please try again later.",
          "unexpected": "PL An unexpected error occurred whilst retrieving your pin."
        },
        "loading": "PL Getting your pin",
        "p1": "PL Thank you for verifying yourself, please copy the code below and enter it in your initial browser.",
        "tap": "PL Tap here to copy",
        "title": "PL Return to your initial browser."
      }
    }
  },
  "component": {
    "privacy_statement_link": {
      "link_text": "PL Privacy Notice"
    }
  },
  "copy": {
    "button": {
      "error": "PL An error occurred copying, please copy the value manually.",
      "success": "PL Copied!"
    }
  },
  "document": {
    "button": {
      "skip": "PL Skip"
    },
    "error": {
      "loading": {
        "faq": "PL We couldn't load the Frequently Asked Questions at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us.",
        "privacy": "PL We couldn't load the Privacy Notice at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us.",
        "tnc": "PL We couldn't load the Terms of Use at this time. Please check your internet connection and retry. If this problem persists, please get in touch with us."
      }
    }
  },
  "email_mfa": {
    "button": {
      "resend": "PL Resend my verification code",
      "verify": "PL Verify",
      "verifying": "PL Verifying"
    },
    "error": {
      "could_not_send": {
        "button": "PL request a new one",
        "end": "PL .",
        "start": "PL There was an error sending a verification code to your email. Please check your internet connection, then "
      },
      "could_not_verify": "PL There was an error verifying your pin.  Please check your internet connection, then hit verify again.",
      "resend_limit": "PL Email resend limit reached.",
      "resent_email": "PL You have failed too many times with the previous code so a new code has been sent to you. Please try again.",
      "timeout": "PL Your code has expired. A new code has been sent."
    },
    "instructions": {
      "email_available": "PL Please enter the 6 digit code which has been sent to this email address.",
      "email_not_available": "PL Please enter the 6 digit code which has been sent to the email address associated with your account."
    },
    "resend_confirmation": "PL Verification has been sent.",
    "title": "PL Verification code"
  },
  "error": {
    "generic": {
      "message": "PL Please get in touch with us about this.",
      "title": "PL Something went wrong"
    }
  },
  "export": {
    "filename": "PL nomidio_id_data"
  },
  "external": {
    "faq": {
      "link": "PL Link to the FAQ."
    },
    "privacy": {
      "link": "PL Click the link to your company's Privacy Policy."
    },
    "systemAdmin": {
      "email": "PL Please contact your system administrator."
    },
    "tnc": {
      "link": "PL Click the link to your company's Terms of Use."
    }
  },
  "face_check": {
    "check": {
      "biometrics": {
        "upload": "PL Uploading your biometrics."
      },
      "button": {
        "camera": "PL Change camera",
        "help": "PL Help",
        "retry": "PL Retry"
      },
      "desktop": {
        "tap_to_start": "PL Click the button below to start recording"
      },
      "instructions": {
        "align": "PL Position your face in the oval. Make sure we can clearly see your eyes",
        "complete": "PL Complete",
        "detected": "PL Hold still!",
        "timed_out": "PL No face detected"
      },
      "loading": "PL Loading…",
      "needs_video": "PL Tap anywhere to activate your webcam",
      "processing": "PL Processing...",
      "refresh": "PL Please don't refresh the page.",
      "tap_start": "PL Tap to start",
      "tap_to_start": "PL Tap here to start",
      "uploading": "PL Uploading..."
    },
    "media_access": {
      "button": {
        "allow": "PL Allow Camera Access"
      },
      "p1": "PL We need your permission to access the camera in order to capture your biometric faceprint.",
      "p2": "PL Please allow access to the camera to do this.",
      "title": "PL Camera Access"
    },
    "media_error": {
      "button": "PL Refresh",
      "p1": "PL Please try refreshing the page or updating the camera access permissions within your browser settings.",
      "title": "PL Camera access denied"
    },
    "orientation_error": {
      "title": "PL Your device is in landscape mode. Please rotate!"
    }
  },
  "forms": {
    "email": {
      "label": "PL Email Address"
    },
    "first_name": {
      "error": {
        "maxlength": "PL First name is too long",
        "pattern": "PL First name is not valid",
        "required": "PL First name is required"
      },
      "label": "PL First name"
    },
    "last_name": {
      "error": {
        "maxlength": "PL Last name is too long",
        "pattern": "PL Last name is not valid",
        "required": "PL Last name is required"
      },
      "label": "PL Last name"
    }
  },
  "help": {
    "app_version": {
      "end": "PL ",
      "start": "PL app version: "
    },
    "face_check": {
      "position": "PL Hold camera at eye level",
      "profile": "PL Light your face evenly"
    }
  },
  "index": {
    "incompatible": {
      "p1": "PL This device or browser is not able to run this application.",
      "p2": "PL You may need to update your software or hardware.",
      "title": "PL Device not supported"
    }
  },
  "iproov": {
    "failed": "PL We couldn't verify your face print",
    "processing": "PL Face biometrics are being processed",
    "timeout": {
      "heading": "PL Failed to initialise",
      "p1": "PL Please retry.",
      "p2": "PL If this problem is persisting, please reload the page."
    }
  },
  "language": {
    "choose": "PL Choose your language:",
    "cimode": "PL Debug"
  },
  "login": {
    "bio_intro": {
      "button": "PL Next",
      "list": {
        "item1": "PL The space is well lit",
        "item2": "PL You hold still for 2–4 seconds",
        "item3": {
          "desktop": "PL You do not cover or obscure your face",
          "mobile": "PL You hold your device in portrait mode"
        }
      },
      "listStart": "PL Please make sure:",
      "title": "PL We will now capture a video to verify your face biometrics"
    },
    "chooseEmail": {
      "error": {
        "p1": "PL Couldn't load this account's emails.",
        "p2": "PL This account doesn't have any verified and approved emails.",
        "p3": "PL Couldn't load this account's emails.",
        "p4": "PL There was an unexpected server error.",
        "p5": "PL There was an error submitting your choice.",
        "p6": "PL Please try again."
      },
      "loading": "PL Loading emails...",
      "p1": "PL Your account has multiple emails available to sign in with. Please choose one to proceed.",
      "retry": {
        "button": "PL Retry"
      },
      "title": "PL Choose an email to sign in with"
    },
    "deleted_dialog": {
      "content": "PL Your account has been successfully deleted from our system.",
      "primary_button": "PL Ok",
      "title": "PL Account deleted."
    },
    "email": {
      "not_registered": {
        "p1": "PL It looks like you do not have an account registered with this email address.",
        "p2": "PL Either you can register with this address, or use a different email address.",
        "register_button": "PL Register",
        "retry_button": "PL Try Again",
        "title": "PL No account"
      }
    },
    "error": {
      "same_browser": {
        "p1": "PL It looks like you opened this link in the same browser you started in. To continue signing in, open the link on the supported browser or device you're switching to.",
        "title": "PL Please use your other browser"
      }
    },
    "failed_dialog": {
      "content": "PL We were unable to verify your identity",
      "primary_button": "PL Ok",
      "server_error": "PL We are currently experiencing issues. Please try again later.",
      "title": "PL Login error."
    },
    "landing": {
      "button": {
        "login": "PL Login",
        "register": "PL Register"
      },
      "error": {
        "account_locked": "PL Your account is currently locked, please try later.",
        "auth_bad_state": "PL Failed to start Auth session.",
        "fail_into_key_recovery": "PL There was a problem logging you in. You will need to log in with your email.",
        "forbidden": "PL You are not authorised for login to this application.",
        "generic": "PL There was a problem logging you in.",
        "invalid_credentials": "PL Invalid credentials provided.",
        "invalid_email": "PL Invalid email provided.",
        "login_timeout": "PL Your session has ended. Please log back in to continue.",
        "max_mfa_reached": "PL OTP resend limit reached.",
        "oauth_bad_state": "PL Could not verify OAuth2 session, please return to the login screen.",
        "recovery_server_error": "PL Your account could not be recovered due to a server error, please try later.",
        "too_many_attempts": "PL We have detected this device has requested too many login attempts. Please try again in 10 minutes.",
        "unexpected_failure": "PL There was a problem logging you in. Please check your internet connection and try again.",
        "verification_image_error": "PL There was a problem loading verification image.",
        "verification_image_match": "PL The verification images linking logins across browsers need to match.",
        "webauthn_cancelled": "PL The passkey request was cancelled. Please try again to log in."
      },
      "key_recovery": {
        "p1": "PL To manage your Nomidio ID you will need to authenticate yourself via face and voice recognition checks.",
        "p2": "PL Please log in with your registered email address."
      },
      "normal": {
        "p1": "PL To manage your Nomidio ID you will need to authenticate yourself via face and voice recognition checks."
      },
      "privacy_link": "PL Privacy Notice",
      "terms_link": "PL Terms of Use",
      "title": "PL Welcome to your Nomidio ID"
    },
    "oauthEnded": {
      "body": "PL You may now close this window.",
      "title": "PL Login complete"
    },
    "polling": {
      "button": {
        "continue": "PL Ok",
        "start_poll": "PL Continue"
      },
      "network_issue": "PL There seems to be an issue with your internet connection.",
      "p1": "PL This may take a few seconds. Please don't refresh the page.",
      "server_error": "PL We are currently experiencing issues. Please try again later.",
      "time_out": "PL It is taking longer than we expected to process your biometric information. Either continue waiting or try again later.",
      "title": "PL We're verifying your identity."
    },
    "retry": {
      "button": "PL Retry",
      "p1": "PL Please try again",
      "title": "PL We couldn't verify you"
    },
    "webauthn": {
      "button": "PL Create my key",
      "details": "PL This will help us verify it's you, and let you verify yourself quickly in the future.",
      "dialog": "PL You may need to confirm this action with your browser or password vault.",
      "error": "PL That didn't work. Try again?",
      "title": "PL Create a key"
    }
  },
  "mfa": {
    "EMAIL": {
      "backup": "PL I cannot access my email",
      "error.could_not_send.button": "PL request a new one",
      "error.could_not_send.end": "PL .",
      "error.could_not_send.start": "PL There was an error sending a verification code to your email. Please check your internet connection, then ",
      "error.invalid_email": "PL Email provided is invalid.",
      "error.resend_limit": "PL Email resend limit reached.",
      "instructions.p1": "PL You have been sent an email containing a 6 digit code.",
      "instructions.p2": "PL Please enter the 6 digit code.",
      "resend": "PL Resend my email verification code",
      "resent": "PL A new code has been emailed to you.",
      "title": "PL Email Verification Code"
    },
    "PHONE": {
      "backup": "PL ",
      "error.could_not_send.button": "PL request a new one",
      "error.could_not_send.end": "PL .",
      "error.could_not_send.start": "PL There was an error sending a verification code to your phone number. Please check your internet connection, then ",
      "error.resend_limit": "PL SMS resend limit reached.",
      "instructions.p1": "PL Please enter the 6 digit code sent in the SMS text message to this phone number.",
      "instructions.p2": "PL ",
      "resend": "PL Resend my text verification code",
      "resent": "PL A new code has been sent to you.",
      "title": "PL Phone Verification Code"
    },
    "TOTP": {
      "backup": "PL I cannot access my authenticator app",
      "instructions.p1": "PL Please enter the 6 digit code displayed in your authenticator app.",
      "instructions.p2": "PL Codes are time limited, so be sure to enter it and click verify before it expires.",
      "resend": "PL ",
      "title": "PL Two-Factor Authentication Code"
    },
    "verify": "PL Verify",
    "verifying": "PL Verifying..."
  },
  "mobile": {
    "download": {
      "hint": "PL If you are having trouble downloading files to your mobile device, please try again on a desktop device."
    }
  },
  "nomidio": {
    "input": {
      "error": {
        "email": "PL Must be a valid email",
        "exactlength": "PL Must have exact length of ",
        "forbidden": "PL This value is not permitted",
        "max": "PL Must be no more than ",
        "maxlength": "PL Must be at most length ",
        "min": "PL Must be at least ",
        "minlength": "PL Must be at least length ",
        "otp": {
          "exactlength": "PL  digits required",
          "pattern": "PL Code must be numbers only",
          "required": "PL Code is required",
          "retry": "PL Incorrect code"
        },
        "pattern": "PL This value is not valid",
        "phone": "PL Must be a valid phone number",
        "required": "PL This field is required"
      }
    },
    "phone": {
      "error": "PL Please choose a different phone number",
      "number": "PL Phone Number"
    }
  },
  "oauth": {
    "abort": {
      "continue": "PL Return",
      "p1": "PL Required data sharing was not approved, login has been aborted.",
      "p2": "PL Login has been aborted.",
      "title": "PL Login Aborted"
    },
    "approval": {
      "button": {
        "accept": "PL Accept",
        "decline": "PL Decline"
      },
      "checkbox": {
        "openid": "PL I consent to using Nomidio ID"
      },
      "default": {
        "p1": {
          "end": "PL .",
          "middle": "PL  has requested sharing your Nomidio ID data with ",
          "start": "PL "
        }
      },
      "openid": {
        "p1": {
          "end": "PL . Please review the following conditions:",
          "middle": "PL  would like to use your Nomidio ID to access ",
          "start": "PL "
        }
      },
      "p2": "PL The following data will be shared:",
      "privacy_policy": {
        "end": "PL .",
        "link": "PL click here",
        "start": "PL For more details on how your data may be used "
      },
      "scope": {
        "email": "PL Email",
        "profile": "PL First and last name"
      },
      "title": "PL Approval"
    },
    "error": {
      "continue": "PL Return",
      "description": {
        "400": "PL You failed one or more checks.",
        "401": "PL You failed one or more checks.",
        "403": "PL You are not authorised for login to this application.",
        "404": "PL Third party login state missing. This may be resolved by trying to log in again.",
        "409": "PL Your session has expired, please try again.",
        "429": "PL You reached a verification limit. This may hinder logins in the next day.",
        "500": "PL An error occurred either on the website or server, please try to log in again.",
        "undefined": "PL An error occurred either on the website or server, please try to log in again."
      },
      "p1": "PL You have failed to authenticate. Please see the error breakdown below for more.",
      "title": "PL Login Failed"
    },
    "login": {
      "landing": {
        "p1": "PL To login using your Nomidio ID you will need to pass a biometric check.",
        "title": "PL Welcome to Sign-In with Nomidio ID"
      }
    }
  },
  "phone_mfa": {
    "button": {
      "resend": "PL Resend my verification code",
      "verify": "PL Verify",
      "verifying": "PL Verifying..."
    },
    "error": {
      "conflict": "PL Phone number already in use.",
      "could_not_send": {
        "button": "PL request a new one",
        "end": "PL .",
        "start": "PL There was an error requesting an SMS verification code. Please check your internet connection, then "
      },
      "could_not_verify": "PL There was an error verifying your pin. Please check your internet connection, then hit verify again.",
      "resend_limit": "PL SMS resend limit reached.",
      "resent_code": "PL You have failed too many times with the previous code so a new code has been sent to you. Please try again.",
      "timeout": "PL Your code has expired. A new code has been sent."
    },
    "instructions": {
      "p1": "PL Please enter the 6 digit code sent in the SMS text message to this phone number."
    },
    "new_pin_dialog": {
      "content": "PL You will receive an SMS with a new 6 digit code",
      "primary_button": "PL Ok",
      "title": "PL Invalid code."
    },
    "resend_confirmation": "PL Verification has been sent.",
    "title": "PL Phone verification code"
  },
  "register": {
    "account_details": {
      "button": "PL Next",
      "intro": "PL Please enter your name so that we can create your Nomidio ID.",
      "title": "PL Account Details"
    },
    "bio_intro": {
      "button": "PL Start",
      "list": {
        "item1": "PL You are in a quiet place",
        "item2": "PL You can speak freely",
        "item3": "PL The space is well lit",
        "item4": "PL There is no bright light directly behind you",
        "item5": {
          "desktop": "PL You do not cover or obscure your face",
          "mobile": "PL Your device is in portrait mode"
        }
      },
      "listStart": "PL Please make sure:",
      "title": "PL When capturing your biometric data for the creation of your Nomidio ID, please make sure that…"
    },
    "consent": {
      "button": {
        "accept": "PL Accept",
        "decline": "PL Decline"
      },
      "checklist": {
        "general": "PL I consent to my personal information being used to create my Nomidio ID.",
        "general_enrol": {
          "end": "PL .",
          "start": "PL I consent to my personal information being used to create my Nomidio ID and to enrolling my Nomidio ID with "
        },
        "privacy": {
          "end": "PL .",
          "link": "PL Privacy Notice",
          "start": "PL I confirm that I have reviewed the "
        },
        "terms": {
          "end": "PL .",
          "link": "PL Terms of Use",
          "start": "PL I confirm that I have reviewed and accept the "
        },
        "title": "PL You must agree to the following to proceed:"
      },
      "decline_dialog": {
        "cancel": "PL Cancel",
        "confirm": "PL Yes",
        "content": "PL You will not be able to create an Nomidio ID",
        "title": "PL Are you sure you want to decline?"
      },
      "error": {
        "bad_request": "PL This should not happen, but your invitation appears to be invalid.",
        "conflict": "PL Unfortunately your invitation cannot be accepted, perhaps it has expired or has been completed.",
        "forbidden": "PL Unfortunately your invitation cannot be accepted, perhaps your phone number is blocked.",
        "unexpected_error": "PL Unfortunately an unexpected error has occurred, please try again."
      },
      "intro": {
        "enrol": {
          "end": "PL  when you complete this registration.",
          "start": "PL We will enrol your Nomidio ID with "
        },
        "p1": "PL To create your Nomidio ID we will need to collect your name, mobile number and email address, as well as your biometric voiceprint and faceprint. We will use this to help you verify your identity with other companies. We will always ask for your permission before verifying your identity with a new company and we will never share your biometric data with anyone unless required to do so by law.",
        "p2": "PL When we verify your identity we may send you an SMS text message with a verification code or link.",
        "withdraw": "PL You will be able to withdraw your consent and manage your other privacy preferences via the web application at any time."
      },
      "submitting": "PL Please wait a moment.",
      "title": "PL We need your consent"
    },
    "consent_declined": {
      "p1": "PL You will not be able to use Nomidio Identity.",
      "title": "PL You have declined the Terms of Use"
    },
    "email": {
      "already_verified": {
        "p1": "PL Please enter your email address. In order to resume registration, email verification pin is required."
      },
      "button": "PL Send Verification Code",
      "error": {
        "already_used": "PL The provided email address is already in use by another user, please try again with a different email.",
        "corporate_email": "PL This email is a corporate email. Please contact an enterprise admin to add it to your account.",
        "email_mismatch": "PL You will need to verify the email address that is assigned to this registration. You can change your email address after completing registration.",
        "invalid_email": "PL The provided email is invalid.",
        "max_retry": "PL Verification code resend limit reached.",
        "sending_email": "PL There was an error sending a verification code to your email. Please try again.",
        "too_many_requests": "PL You are sending too many requests. Please wait some time before trying again."
      },
      "expired_notice": "PL The authentication code sent to your email has expired. Please re-submit your email for verification.",
      "p1": "PL Please enter your email address. You will be sent a 6 digit code that must be entered in order to link your email address to your Nomidio ID account.",
      "title": "PL Account Details"
    },
    "email_confirmed": {
      "primary_button": "PL Ok",
      "title": "PL Your email has been successfully verified"
    },
    "expired": {
      "p1": "PL You took too long to complete your session.",
      "p2": "PL You may leave this page.",
      "title": "PL Sorry, this invitation has expired"
    },
    "face": {
      "camera": {
        "content": "PL Choose a connected camera from your list.",
        "error": {
          "content": "PL You may need to pick a different video source.",
          "title": "PL Can't use this camera"
        },
        "save": "PL Save",
        "title": "PL Change Camera"
      }
    },
    "face_failed": {
      "button": "PL Retry",
      "error": {
        "bad_contrast": "PL Your faceprint has poor contrast, please try again.",
        "bad_dynamic_range": "PL Your faceprint is poorly lit and has low contrast, please try again.",
        "bad_exposure": "PL The exposure of your faceprint is not strong enough, please try again.",
        "bad_lighting": "PL Your faceprint has poor lighting, please try again in a better lit environment.",
        "bad_object": "PL Your faceprint was not good enough for biometric processing, please try again.",
        "bad_pose": "PL Please retry by holding your camera upright.",
        "bad_sharpness": "PL Please retry by holding your camera firmly.",
        "expired": "PL Your challenge or invitation has expired.",
        "internal_error": "PL An unexpected error has occurred, please try again. Error code: INTERNAL_ERROR.",
        "invalid_media": "PL We were unable to process this faceprint, please try again.",
        "invalid_sample_resolution": "PL The resolution of your faceprint was not high enough, please try again.",
        "object_not_found": "PL Unable to clearly detect your face, please try again.",
        "occlusion": "PL It looks like something got in the way of your face, please try again.",
        "too_few_features": "PL Unable to detect your face in enough detail, please try again.",
        "too_few_objects": "PL Your faceprint did not contain enough detail to process, please try again.",
        "too_noisy": "PL The quality of your faceprint was not good enough for biometric processing, please try again.",
        "unknown": "PL An unexpected error has occurred, please try again.",
        "user_not_active": "PL An unexpected error has occurred, please try again. Error code: USER_NOT_ACTIVE."
      },
      "title": "PL We couldn’t successfully capture your faceprint"
    },
    "iproov": {
      "retry": "PL Retry"
    },
    "landing": {
      "button": "PL Get Started",
      "error": {
        "invalid": "PL This invitation is not valid. Check you accessed the most recent link.",
        "session": "PL The registration session expired. Please re-submit your details."
      },
      "p1": "PL Prove your identity to trusted companies and control the data you share with them.",
      "title": "PL Create Your Nomidio ID"
    },
    "link": {
      "failed_dialog": {
        "primary_button": "PL Ok"
      }
    },
    "oauth_final": {
      "p1": {
        "end": "PL  to login with your newly created account.",
        "start": "PL You are now successfully registered. Please return to "
      },
      "title": "PL Registration Complete"
    },
    "phone": {
      "already_verified": {
        "p1": "PL Please enter your phone number. In order to resume registration, phone verification pin is required."
      },
      "button": "PL Send Verification Code",
      "error": {
        "already_used": "PL The provided phone number is already in use by another user, please try again with a different phone number.",
        "invalid_mobile": "PL This is not a valid mobile number.",
        "max_retry": "PL Verification code resend limit reached.",
        "phone_mismatch": "PL You will need to verify the phone number that is assigned to this registration. You can change your phone number after completing registration.",
        "sending_phone": "PL There was an error sending a verification code to your phone. Please try again.",
        "too_many_requests": "PL You are sending too many requests. Please wait some time before trying again."
      },
      "expired_notice": "PL The authentication code sent to your phone has expired. Please re-submit your phone number for verification.",
      "p1": "PL Please enter your phone number. You will be sent a 6 digit code that must be entered in order to link your phone to your Nomidio ID account.",
      "skip": "PL Skip",
      "title": "PL Account Details"
    },
    "phone_confirmed": {
      "button": "PL Ok",
      "title": "PL Your phone number has been successfully verified"
    },
    "post_creation": {
      "continue": "PL Continue",
      "option": {
        "avatar": {
          "cta": "PL Upload",
          "desc": "PL Personalise your account by adding an avatar.",
          "label": "PL Upload a profile picture"
        },
        "totp": {
          "cta": "PL Set Up",
          "desc": "PL Add an extra layer of security to your account.",
          "label": "PL Add Two-Factor Authentication"
        }
      },
      "p1": "PL Your account has been created. You can add the following optional details now, or set them up later.",
      "title": "PL You're all set"
    },
    "redirect": {
      "link": "PL click here",
      "p1": "PL You have completed registration and will now be redirected for the next part of the process.",
      "p2": "PL This should take only a few seconds. If nothing happens, please ",
      "title": "PL Redirecting..."
    },
    "renew": {
      "button": "PL Resume",
      "error": {
        "could_not_renew": "PL We could not renew your invitation. Please try again."
      },
      "p1": "PL This registration was left for a long time before completion. You'll need to re-do part of the registration.",
      "title": "PL Resuming registration"
    },
    "skip": {
      "interaction": "PL Don't show this to me again"
    },
    "summary": {
      "button": "PL Submit",
      "email": "PL Email",
      "name_edit": "PL Edit",
      "phone": "PL Mobile number",
      "title": "PL Verify Personal Data"
    },
    "totp": {
      "p1": "PL Add two-factor authentication using an authenticator app",
      "qr": {
        "loading": "PL Loading QR code..."
      },
      "step1": {
        "title": "PL Step 1. Scan the QR code"
      },
      "step2": {
        "title": "PL Step 2. Enter your security code"
      },
      "submit": "PL Confirm",
      "title": "PL Two-Factor Authentication"
    },
    "verify_face": {
      "failed": {
        "button": "PL Retry",
        "p1": "PL We couldn't verify your biometrics, please try again.",
        "title": "PL Failed!"
      },
      "intro": {
        "button": "PL Continue",
        "option": {
          "iproov.desc": "PL Fastest and most secure method.",
          "iproov.label": "PL Use iProov verification",
          "recommended": "PL Recommended",
          "standard.desc": "PL This process may take longer.",
          "standard.label": "PL Use an alternative method"
        },
        "p1": "PL To confirm your account is secure, we need to confirm your identity using a quick biometric scan.",
        "p2": {
          "href": "PL https://www.iproov.com/blog/iproov-safeguards-for-people-with-photosensitive-epilepsy",
          "part1": "PL We use ",
          "part2": "PL iProov",
          "part3": "PL , a secure biometric verification service. iProov uses your device's camera and may include a brief sequence of flashing lights to confirm you are a real person.",
          "title": "PL How does it work"
        },
        "p3": "PL You can update your consent anytime in your account settings.",
        "title": "PL Verifying your face"
      },
      "opt_out_dialog": {
        "cancel": "PL Cancel",
        "confirm": "PL Opt out",
        "p1": "PL By opting out of iProov verification, you'll need to verify your identity using an alternative method, which may take more time.",
        "p2": "PL Do you still want to opt out of using iProov?",
        "title": "PL Opt out"
      },
      "retry": {
        "p2": "PL You will need to re-register your biometrics.",
        "title": "PL Repeat Biometric"
      }
    },
    "verify_voice": {
      "failed": {
        "button": "PL Retry",
        "p1": "PL We couldn't complete your voice print. Please try again.",
        "title": "PL Failed!"
      }
    },
    "webauthn": {
      "button": "PL Create my key",
      "details": "PL This will help us verify it's you, and let you verify yourself quickly in the future.",
      "dialog": "PL You may need to confirm this action with your browser or password vault.",
      "error": "PL That didn't work. Try again?",
      "title": "PL Create a key"
    }
  },
  "registration": {
    "consent": {
      "button": {
        "accept": "PL Accept",
        "decline": "PL Decline"
      },
      "checklist": {
        "general": "PL I consent to my personal information being used to create my Nomidio ID.",
        "privacy": {
          "end": "PL .",
          "link": "PL Privacy Notice",
          "start": "PL I confirm that I have reviewed the "
        },
        "terms": {
          "end": "PL .",
          "link": "PL Terms of Use",
          "start": "PL I confirm that I have reviewed and accept the "
        },
        "title": "PL You must agree to the following to proceed:"
      },
      "intro": {
        "p1": "PL To create your Nomidio ID we will need to collect your name, mobile number and email address, as well as your biometric voiceprint and faceprint. We will use this to help you verify your identity with other companies. We will always ask for your permission before verifying your identity with a new company and we will never share your biometric data with anyone unless required to do so by law.",
        "p2": "PL When we verify your identity we may send you an SMS text message with a verification code or link.",
        "p3": "PL You will be able to withdraw your consent and manage your other privacy preferences via the web application at any time."
      },
      "title": "PL We need your consent"
    },
    "creating": {
      "p1": "PL We're setting up the rest of your registration, please wait.",
      "title": "PL Creating your registration"
    },
    "email": {
      "button": "PL Send Verification Code",
      "error": {
        "already_used": "PL The provided email address is already in use by another user, please try again with a different email.",
        "invalid_email": "PL The provided email is invalid.",
        "unexpected_failure": "PL There was an error sending a verification code to your email. Please try again."
      },
      "expired_notice": "PL The authentication code sent to your email has expired. Please re-submit your email for verification.",
      "p1": "PL Please enter your email address. You will be sent a 6 digit code that must be entered in order to verify your email.",
      "title": "PL Email"
    },
    "error": {
      "corporate_email": {
        "button": {
          "retry": "PL Use Different Email"
        },
        "p1": "PL The email you have provided is a corporate email. Please contact an enterprise admin to add it to your account.",
        "p2": "PL You should register using a personal email.",
        "title": "PL Corporate Email"
      },
      "email_in_use": {
        "button": {
          "login": "PL Login",
          "retry": "PL Use Different Email"
        },
        "p1": "PL The email you verified is already connected to an account.",
        "p2": "PL You may try to register using a different email or log in with your verified email.",
        "title": "PL Email in Use"
      },
      "email_phone_in_use": {
        "button": {
          "retry": "PL Use Different Details"
        },
        "p1": "PL Both the email and phone number you verified are already connected to accounts.",
        "p2": "PL You may try to register different details.",
        "title": "PL Phone and Email in Use"
      },
      "email_restricted": {
        "p1": "PL You are not authorised to register with this link.",
        "title": "PL Registration Forbidden"
      },
      "invalid_domain": {
        "p1": "PL We could not find the link you used, this could be because the link does not exist, or the link has not been activated.",
        "p2": "PL Unfortunately you cannot proceed with registration.",
        "title": "PL Registration link not found"
      },
      "link_not_found": {
        "p1": "PL We could not find the link you used, this could be because the link does not exist, or the link has expired.",
        "p2": "PL Unfortunately you cannot proceed with registration.",
        "title": "PL Registration link not found"
      },
      "phone_in_use": {
        "button": {
          "login": "PL Login",
          "retry": "PL Use Different Number"
        },
        "p1": "PL The phone number you verified is already connected to an account.",
        "p2": "PL You may try to register using a different phone number or log in to the existing account.",
        "title": "PL Phone number in Use"
      },
      "server_error": {
        "button": "PL Try Again",
        "p1": "PL We are currently experiencing issues registering you, please wait then try again.",
        "title": "PL Server Error"
      },
      "session_expired": {
        "button": "PL Restart",
        "p1": "PL The registration session expired. Please re-submit your details.",
        "title": "PL Session Expired"
      },
      "too_many_requests": {
        "p1": "PL You are sending too many requests. Unfortunately you cannot proceed with registration.",
        "title": "PL Too Many Requests"
      },
      "user_already_registered": {
        "button": {
          "login": "PL Login"
        },
        "p1": "PL The email and phone number you verified are already connected to an account.",
        "title": "PL User Already Registered"
      }
    },
    "phone": {
      "button": "PL Send Verification Code",
      "error": {
        "invalid_mobile": "PL This is not a valid mobile number."
      },
      "p1": "PL Please enter your mobile number. You will be sent a 6 digit code which must be entered in order to verify your mobile number.",
      "title": "PL Mobile Number"
    }
  },
  "shared": {
    "notFound": {
      "p1": "PL The page you requested was not found.",
      "title": "PL Not Found"
    }
  },
  "theme": {
    "color": {
      "title": "PL Color scheme"
    },
    "picker": {
      "dark": "PL Dark mode",
      "light": "PL Light mode",
      "system": "PL System"
    }
  },
  "title": "PL Nomidio Identity",
  "topmenu": {
    "back": "PL Go back",
    "help": "PL View FAQ",
    "logo": {
      "alt": "PL Nomidio Identity"
    },
    "switch_user": "PL Switch user"
  },
  "totp_code": {
    "copied_secret": "PL Secret Copied",
    "copy_secret": "PL Copy Secret",
    "p1": "PL Scan the QR code with your authenticator app or manually enter the secret.",
    "p2": "PL On a mobile device, you can tap the QR code to configure Google Authenticator (if it is installed).",
    "view_qr": "PL View QR",
    "view_secret": "PL View Secret"
  },
  "unsupported": {
    "browser": {
      "challenge": {
        "error": {
          "preselected": "PL You have already selected a challenge image.",
          "unexpected": "PL An unexpected error occurred whilst selecting image."
        }
      },
      "code": {
        "error": {
          "challenge": "PL Login on supported browser is not completed yet",
          "invalid": "PL Submitted code was invalid",
          "unexpected": "PL An unexpected error occurred whilst verifying your code"
        }
      },
      "copy": {
        "button": "PL Copy link to clipboard"
      },
      "error": {
        "auth": "PL Failed to retrieve login url, missing auth code.",
        "server": "PL Failed to retrieve login url due to server error, please try later."
      },
      "image": {
        "button": "PL Select Image"
      },
      "p1": "PL Looks like you are using an unsupported browser. You can still complete a login via another browser by following the instructions.",
      "step1": {
        "p1": "PL For security purposes, pick an image which will be used to link the login across browsers.",
        "title": "PL Step 1. Select image"
      },
      "step2": {
        "p1": "PL Complete login on supported browser with microphone and camera access via the link in order to get verification code.",
        "p2": {
          "part1": "PL Scan the QR code or copy ",
          "part2": "PL  into a supported browser."
        },
        "p3": "PL The image you picked in step 1 should be shown.",
        "title": "PL Step 2. Login via Link"
      },
      "step3": {
        "p1": "PL Upon successful login, a verification code will be displayed. Please enter the code below.",
        "title": "PL Step 3. Enter Verification Code"
      }
    }
  },
  "user_details_dialog": {
    "a": "PL Why do I have to do this?",
    "cancel": "PL Cancel",
    "confirm": "PL Confirm",
    "p1": "PL To confirm your identity without 2FA or email verification, you will need to provide additional account details.",
    "p2": {
      "phone": "PL Please enter your primary phone number below to continue."
    },
    "title": "PL We need some information"
  },
  "voice_check": {
    "dialog": {
      "mic_troubleshoot": {
        "list": {
          "item1": "PL Your microphone is unmuted.",
          "item2": "PL You're not using your microphone already for a voice call.",
          "item3": "PL The correct microphone is selected.",
          "item4": "PL You're speaking clearly into your microphone."
        },
        "ok": "PL Ok",
        "p1": "PL Please ensure:",
        "p2": "PL Your page will now reload.",
        "title": "PL No audio detected"
      }
    },
    "media_access": {
      "button": "PL Allow Microphone Access",
      "p1": "PL We need your permission to access the microphone to capture your biometric voiceprint.",
      "p2": "PL Please allow access to the microphone to do this.",
      "title": "PL Microphone Access"
    },
    "media_error": {
      "button": "PL Refresh",
      "p1": "PL Please try refreshing the page or updating the microphone access permissions within your browser settings.",
      "title": "PL Microphone access denied"
    },
    "record": {
      "hint": {
        "firstRecording": "PL Tap the record button and say the phrase above, then tap again to stop.",
        "polling": "PL Checking with the server ...",
        "tapAgain": "PL Tap again to finish recording",
        "tooLong": "PL That took too long. You need to tap the record button to end the recording.",
        "tooQuiet": "PL We couldn't pick up any audio.",
        "tooShort": "PL That was too short. You need to speak slower.",
        "training2": "PL Now record the phrase again",
        "verification1": "PL Now we need to verify things are set up correctly. Record the phrase again.",
        "verification2": "PL Now record the phrase again",
        "waitingForUploads": "PL Waiting for uploads to complete ..."
      },
      "phrase": "PL “I use my voice to prove my identity”",
      "recordButtonText": {
        "tapStart": "PL Tap to start",
        "tapStop": "PL Tap to stop",
        "uploading": "PL Uploading"
      }
    }
  }
}
